import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const editOteConType = ( {data, oteConTypeId} : {data: IPostEditOteConType | {}, oteConTypeId: number}): Promise<string> => {
  return axiosDefaultApi.put(`/api/OteConTypes/UpdateOteConType/${oteConTypeId}`, data);
};

type QueryFnType = typeof editOteConType;

type UseEditOteConTypeOptions = {
  data: IPostEditOteConType | {};
  oteConTypeId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditOteConType = ({ config }: UseEditOteConTypeOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία του Είδους γραμμής ΟΤΕ.`, 500);
            console.error('Couldnt edit OteConType', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllOteConTypes"])
            addNotification('Το Είδος γραμμής ΟΤΕ Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editOteConType,
    })
}